import React, { FC } from 'react';
import { GoodPage } from 'app/pages';
import { ICatalog } from 'entities/Catalog/Catalog.models';
import { CatalogHeader, CatalogNavigation } from 'entities/Catalog/components';

interface IComponentProps {
  catalog: ICatalog;
}

export const CatalogGoodPage: FC<IComponentProps> = ({ catalog }) => {
  return (
    <div className="redesign relative pt-11 px-11 h-full flex direction-column" style={{ minWidth: 1360 }}>
      <CatalogHeader catalog={catalog} />

      <div className="flex direction-column flex-1 overflow-y-scroll scrollbar-none">
        <div className="mx-11 flex direction-column flex-1">
          <div style={{ width: '100%', maxWidth: 1840, margin: '0px auto' }}>
            <CatalogNavigation catalog={catalog} />
          </div>

          <GoodPage />
        </div>
      </div>
    </div>
  );
};
